import React, { useState } from 'react';
import { formatKeywordsWithCommas, handleTooltip, useTooltip } from '../Helpers/KeywordUtils';
import Tooltip from '../Helpers/Tooltip';
import stratagemsData from '../Data/stratagemsData.json';

function AbilitiesContainer({ selectedData }) {
    const {
        tooltipVisible,
        setTooltipVisible,
        tooltipContent,
        setTooltipContent,
        tooltipPosition,
        setTooltipPosition,
    } = useTooltip();

    const [selectedStratagem, setSelectedStratagem] = useState(null);
    const [showBoardingActions, setShowBoardingActions] = useState(false);

    const handleSpecialRuleClick = (event, rule) => {
        handleTooltip(event, rule, selectedData, setTooltipContent, setTooltipPosition, setTooltipVisible);
    };

    const handleCheckboxChange = (event) => {
        setShowBoardingActions(event.target.checked);
    };

    const filteredStratagems = selectedData.STRATAGEMS
        ? selectedData.STRATAGEMS.filter((stratagem) => {
            const stratagemData = stratagemsData.find((strat) => strat.name.toLowerCase() === stratagem.toLowerCase());
            if (!stratagemData) return false;
            return showBoardingActions ? stratagemData.type.includes('Boarding Actions') : !stratagemData.type.includes('Boarding Actions');
        })
        : [];

    const handleStratagemClick = (event, stratagemName) => {
        const stratagem = stratagemsData.find((strat) => strat.name.toLowerCase() === stratagemName.toLowerCase());
        if (stratagem) {
            setSelectedStratagem(stratagem);
            setTooltipVisible(false);
        }
    };

    const parseDescription = (description) => {
        const parts = description.split(/(WHEN:|TARGET:|EFFECT:)/).filter(Boolean);
        const parsed = {};
        for (let i = 0; i < parts.length; i += 2) {
            parsed[parts[i].replace(':', '').trim()] = parts[i + 1].trim();
        }
        return parsed;
    };

    return (
        <div className="mt-6 pb-12">
            {selectedData && (
                <div className="space-y-4">
                    <div>
                        <strong>Core abilities:</strong>
                        <div>
                            {selectedData.ABILITIES && selectedData.ABILITIES['CORE ABILITIES']
                                ? formatKeywordsWithCommas(selectedData.ABILITIES['CORE ABILITIES'], handleSpecialRuleClick)
                                : null}
                        </div>
                    </div>
                    <div>
                        <strong>Faction abilities:</strong>
                        <div>
                            {selectedData.ABILITIES && selectedData.ABILITIES['FACTION ABILITIES']
                                ? formatKeywordsWithCommas(selectedData.ABILITIES['FACTION ABILITIES'], handleSpecialRuleClick)
                                : null}
                        </div>
                    </div>
                    <div>
                        <strong>Other abilities: </strong>
                        <div>
                            {selectedData.ABILITIES && selectedData.ABILITIES['OTHER ABILITIES']
                                ? formatKeywordsWithCommas(selectedData.ABILITIES['OTHER ABILITIES'], handleSpecialRuleClick)
                                : null}
                        </div>
                    </div>
                    <div>
                        <strong>Stratagems: </strong>
                        <div>
                            {filteredStratagems.length > 0
                                ? formatKeywordsWithCommas(filteredStratagems, handleStratagemClick)
                                : 'No stratagems found'}
                        </div>
                    </div>
                    <label className="flex items-center space-x-2">
                        <input
                            type="checkbox"
                            checked={showBoardingActions}
                            onChange={handleCheckboxChange}
                        />
                        <span>Show only Boarding Actions</span>
                    </label>
                    {selectedStratagem && (
                        <div className="mt-4 p-4 border rounded bg-slate-100">
                            <h3 className="font-bold text-lg">{selectedStratagem.name}</h3>
                            <p><strong>CP Cost:</strong> {selectedStratagem.cp_cost}</p>
                            <p><strong>Type:</strong> {selectedStratagem.type}</p>
                            <p><strong>Turn:</strong> {selectedStratagem.turn}</p>
                            <p><strong>Phase:</strong> {selectedStratagem.phase}</p>
                            {Object.entries(parseDescription(selectedStratagem.description)).map(([key, value]) => (
                                <p key={key}><strong>{key}:</strong> {value}</p>
                            ))}
                        </div>
                    )}
                </div>
            )}

            <Tooltip
                visible={tooltipVisible}
                content={tooltipContent}
                position={tooltipPosition}
                onClick={() => setTooltipVisible(false)}
            />
        </div>
    );
}

export default AbilitiesContainer;